import { z } from "zod";
import { Operation, OperationSchema } from "./operations";

declare const DeltaBrand: unique symbol;
export interface Delta {
  readonly [DeltaBrand]: true;
  schema_version: "1";
  operations: Operation[];
}

export const DeltaSchema = z.object({
  schema_version: z.literal("1"),
  operations: z.array(OperationSchema).min(1),
});

export function makeDelta(operations: Operation[]) {
  return DeltaSchema.parse({
    schema_version: "1",
    operations,
  }) as Delta;
}
